// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__MOa9k","title":"Sidebar_title__ysC0L","list":"Sidebar_list__+uvNk","list_item":"Sidebar_list_item__O-VFJ"};